module.exports = __webpack_public_path__ + "img/141.001c5881.jpg";